
import { defineComponent } from 'vue'
import recherchevehicule from "@/services/recherche_page.services";


export default defineComponent({
  name: 'containerComponent',

  setup: () => {
    const { 
      state, 
      openFilter
    } = recherchevehicule;
    return {
      state,
      openFilter
    }
  }
})
